import React from 'react';
import cipsc from '../images/cipsc-n.svg';

const Header = () => {
    return (
        <div className="c-header u-wrapper">
            <a href="/">
                <img src={cipsc} alt="Coloriuris" className='c-header__logo'/>
            </a>
            <div className="c-header__nav js-nav"></div>
        </div>
    );
}

export default Header;
